// CloudPouch 2.0 links, kept in one place.

const DOCS = 'https://docs.cloudpouch.dev';

// Docs are a separate release. Check every URL below returns 200
// before the deploy (curl -sI <url>).
export const DOCS_LINKS = {
  // The three pages below exist in docs 2.0 (branch docs-2.0) at these paths
  // and return 404 until docs 2.0 is published. Check for 200 before the deploy.
  privacy: `${DOCS}/concepts/privacy-and-data-handling/`,
  limitations: `${DOCS}/reference/limitations/`,
  connectAssistant: `${DOCS}/guides/connect-cloudpouch-to-an-ai-assistant/`,
};

export const HOMEBREW_STEP_SENTENCE =
  'On a Mac with Homebrew, brew install cloudpouch does the same job.';

// Hero film. Decision D1 stays: the slot returns to the 32 s premiere film.
// Until then it plays a temporary tour (social cut, 59.2 s). Its words are
// burned into the picture, so it has no caption track. To switch to the
// premiere film, copy its files to website/static/video/ and change the paths
// (captions is optional and takes a .vtt path); null shows a visible
// placeholder instead.
export const HERO_VIDEO = {
  src: '/video/cloudpouch-tour-v8m-1920x1080.mp4',
  poster: '/video/cloudpouch-tour-poster.jpg',
};

// Billing screenshot of CloudPouch 2.0 for the #service_costs section
// (decision D2: one image), files in website/static/screens/. null shows a
// visible placeholder instead. height is the real pixel height of the
// 1600 px file.
export const BILLING_SCREENSHOT = {
  name: 'cloudpouch-2-billing',
  width: 1600,
  height: 1098,
};

// Installer download links. null: the buttons look the latest release up on
// GitHub once per page (see TrialDownloadButton/latestInstallers.js). When the
// app's releases carry fixed file names (electron-builder artifactName), set the
// three links and the page makes no request to api.github.com at all:
//   export const DOWNLOAD_URLS = {
//     dmg: 'https://github.com/CloudPouch/CloudPouch.dev/releases/latest/download/CloudPouch-universal.dmg',
//     exe: 'https://github.com/CloudPouch/CloudPouch.dev/releases/latest/download/CloudPouch-Setup.exe',
//     AppImage: 'https://github.com/CloudPouch/CloudPouch.dev/releases/latest/download/CloudPouch.AppImage',
//   };
export const DOWNLOAD_URLS = null;

// Access logs of the CloudFront distribution (counts visits and downloads per
// campaign without cookies). The privacy policy mentions them only while this
// is true: switch it on in the same release that turns the logs on in AWS
// (serverless.yml), never before.
export const ACCESS_LOGS = true;
